<template>
  <span hidden>
    websocket
    <b-modal id="websocketsModal" title="System Message" ok-only hide-footer>
      {{ text }}
    </b-modal>
  </span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import Gameboard from '~/pages/modules/gameboard/index.vue'

export default {
  data: () => ({
    groupID: '',
    text: '',
  }),

  computed: {
    ...mapGetters({
      user: 'auth/user',
      events: 'getCompletedEvents',
      unread: 'email/unreadEmails',
      classId: 'auth/classId',
    }),
  },

  created() {
    this.CreateWebsocket()
  },

  methods: {
    ...mapActions({
      populateStateFromDB: 'events/populateStateFromDB',
      clearState: 'events/clearState',
      newMove: 'gameboard/newMove',
      saveGameboard: 'gameboard/saveState',
      processEvent: 'events/processEvent',
      updateOnlineRoles: 'group/updateOnlineRoles',
      addOnlineRole: 'group/addOnlineRole',
      removeOnlineRole: 'group/removeOnlineRole',
      updateSession: 'cirt/updateSession',
    }),

    CreateWebsocket: function() {
      // axios call to check sim progress and if at 0 call mixins with event 0
      this.$store.dispatch('events/populateStateFromDB', this)

      axios.post('/api/getGroup', {
        params: {
          pcs: localStorage.getItem('pcs'),
          classId: this.classId,
        },
      })
        .then(response => {
          this.groupID = response.data
          if (this.groupID !== null && this.groupID !== "") {
            // check for any new events
            this.ProcessNewEvents(this.groupID)
            // eslint-disable-next-line no-undef
            Echo.join('group.' + this.groupID)
              .here(users => {
                this.updateOnlineRoles(users)
              })
              .joining(user => {
                this.addOnlineRole(user.id)
              })
              .leaving(user => {
                this.removeOnlineRole(user.id)
                let startingPlaytest = this.$store.state.cirt.startingPlaytest
                let playtestStarterId = this.$store.state.cirt.playtestStarterId
                let playtestConfig = this.$store.state.cirt.playtestConfig
                if (localStorage.getItem('pcs') == 1 && startingPlaytest && playtestStarterId === user.id) {
                  this.$store.dispatch('cirt/startPlaytest', playtestConfig)
                }
              })
              .listen('ProcessEvent', (event) => {
                this.ProcessTeammateEvent(event.content)
              })
              .listen('CirtUpdate', (event) => {
                this.updateSession(event)
              })
              .listen('MoveToken', (event) => {
                this.$store.state.gameboard.tokens.players.forEach(token => {
                  if (event.token !== 'analysis') {
                    document.getElementById(event.token).setAttribute('x', event.x)
                    document.getElementById(event.token).setAttribute('y', event.y)
                    Gameboard.methods.checkTileOccupants(event.tile, false)
                    Gameboard.methods.checkTileOccupants(event.start, false)
                  }
                  if (token.type === event.token) {
                    token.actions.available -= event.moves
                  }
                })
              })
              .listen('CaseletUpdate', (event) => {
                let temp = this.$store.state.gameboard.caseletBank.active
                temp.forEach(caselet => {
                  if (caselet.id === event.caselet) {
                    caselet.hidden = event.updated.hidden
                    caselet.notified = event.updated.notified
                    if (!caselet.resolved && event.updated.resolved) {
                      Object.keys(caselet.score).forEach(category => {
                        this.$store.state.gameboard.scores[category] += caselet.score[category]
                        this.showModal('Caselet was resolved in ' + caselet.tile)
                      })
                      document.getElementById(event.caselet).remove()
                      caselet.resolved = event.updated.resolved
                    } else {
                      document.getElementById(event.caselet).setAttribute('visibility', 'visible')
                    }
                  }
                })
                this.$store.state.gameboard.caseletBank.active = temp
              })
              .listen('UpdateGameboardMarkers', (event) => {
                console.log('marker Update')
                let id = event.type + '_' + event.x + '_' + event.y
                if (event.action === 'create') {
                  console.log('create')
                  let svg = this.$store.state.gameboard.tokenSvg.caselets[event.type]
                  let html = '<svg class="marker" id="' + event.type + '_' + event.x + '_' + event.y + '" ref="' + event.type + ' marker" x="' + event.x.toString() + '" y="' + event.y.toString() + '">' + svg + '</svg>'
                  document.getElementById('Caselets').innerHTML += html
                  this.$store.state.gameboard.markers.push({
                    type: event.type,
                    x: event.x,
                    y: event.y,
                  })
                } else {
                  console.log('remove')
                  document.getElementById(id).remove()
                  for (let i = this.$store.state.gameboard.markers.length - 1; i >= 0; i--) {
                    let marker = this.$store.state.gameboard.markers[i]
                    let check = marker.type + '_' + marker.x + '_' + marker.y
                    if (check === id) {
                      this.$store.state.gameboard.markers.splice(i, 1)
                    }
                  }
                }
              })
              .listen('ProgressDay', (event) => {
                if (this.$store.state.gameboard.day !== this.$store.state.gameboard.rules.totalDays) {
                  alert('End of day ' + this.$store.state.gameboard.day)
                  this.$store.state.gameboard.day += 1
                  this.$store.state.gameboard.tokens.players.forEach(token => {
                    token.actions.available = token.actions.total
                  })
                } else {
                  alert('Game Over')
                }
              })
              .listen('GameboardReset', (event) => {
                window.location.reload(false)
              })
          }
        })
    },

    ProcessTeammateEvent: function(event) {
      this.processEvent({eventId: event, teammateEvent: true})
    },

    ProcessNewEvents: function(group) {
      axios.post('/api/processNewEvents', {
        params: {
          group: group,
        },
      })
        .then(response => {
          if (response.data.length > 0 && response.data[0].completed_events !== null) {
            let groupCompletedEvents = response.data[0].completed_events.substring(1, response.data[0].completed_events.length - 1).split(', ').map(Number)
            groupCompletedEvents = groupCompletedEvents.filter((e, index) => {
              return groupCompletedEvents.indexOf(e) === index
            })

            let userCompletedEvents = this.$store.state.events.completedEvents
            // e = event
            // i = index of e in concatenation of groupCompletedEvents and userCompletedEvents
            // array = 
            let diff = groupCompletedEvents.concat(userCompletedEvents).filter(function(e, i, array) {
              // Check if the element is appearing only once
              return array.indexOf(e) === array.lastIndexOf(e)
            })
            diff.forEach((event, index) => {
              if (event !== 0) this.processEvent({eventId: event})
            })
          }
        })
    },

    showModal(text) {
      this.text = text
      this.$bvModal.show('websocketsModal')
      setTimeout(() => {
        this.$bvModal.hide('websocketsModal')
      }, 1000)
    },
  },
}
</script>
